import { create } from 'zustand';
import { AppMode } from '@k-ucap/shared';

interface AppState {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
  currentProjectId: string | null;
  setCurrentProjectId: (id: string | null) => void;
  presentationMode: boolean;
  setPresentationMode: (enabled: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  mode: AppMode.MOCK,
  setMode: (mode) => set({ mode }),
  currentProjectId: null,
  setCurrentProjectId: (id) => set({ currentProjectId: id }),
  presentationMode: false,
  setPresentationMode: (enabled) => set({ presentationMode: enabled }),
}));
